<template>
	<div class="partGroup">
		<!--零件组详情弹出框-->
		<el-dialog
			:title="dialogDetails.name?dialogDetails.name:'暂无灯组名称'"
			:visible.sync="dialogVisible"
			width="650px"
			:close="handleClose">
			<div class="dialogMain cf">
				<div class="fl" style="width: 48%;">
					<dl>
						<dt>灯组名称：</dt>
						<dd class="cf">
							{{dialogDetails.name?dialogDetails.name:"暂无灯组名称"}}
						</dd>
					</dl>
					<dl>
						<dt>所属系列：</dt>
						<dd class="cf">
							{{seriesIdtoName(dialogDetails.seriesId)}}
						</dd>
					</dl>
					<dl>
						<dt>价格：</dt>
						<dd class="cf">
							{{dialogDetails.price?dialogDetails.price:"暂无价格"}}
						</dd>
					</dl>
					<dl>
						<dt>零件缩略图：</dt>
						<dd class="cf">
							<div style="border: 1px solid #ddd; text-align: center; width: 170px;">
								<img :src="dialogDetails.imgUrl" width="100%" alt="暂无图片"/>
							</div>							
						</dd>
					</dl>
				</div>
				<div class="fr" style="width: 48%;padding-right: 10px;">
					<dl>
						<dt>用户名：</dt>
						<dd class="cf">
							{{dialogDetails.realName?dialogDetails.realName:"暂无用户名"}}
						</dd>
					</dl>
					<dl>
						<dt>用户账号：</dt>
						<dd class="cf">
							{{dialogDetails.userAccount?dialogDetails.userAccount:"暂无用户账号"}}
						</dd>
					</dl>
					<dl>
						<dt>所属类型：</dt>
						<dd class="cf">
							{{dialogDetails.baseType==1?"个人库":"公共库"}}
						</dd>
					</dl>
					<dl>
						<dt>审核状态：</dt>
						<dd class="cf">
							{{auditTypeFn(dialogDetails.audit)}}
						</dd>
					</dl>
					<dl>
						<dt>资源路径：</dt>
						<dd class="cf">
							<input type="" class="input" placeholder="暂无资源路径" style="border: none;" v-model="dialogDetails.filePath" disabled/>
						</dd>
					</dl>
					<dl>
						<dt>创建时间：</dt>
						<dd class="cf">
							{{dataTimeFn(dialogDetails.createTime)}}
						</dd>
					</dl>
					<dl>
						<dt>修改时间：</dt>
						<dd class="cf">
							{{dataTimeFn(dialogDetails.modifyTime)}}
						</dd>
					</dl>
					<dl>
						<dt>描述：</dt>
						<dd class="cf">
							<div>
								{{dialogDetails.description?dialogDetails.description:"暂无描述"}}
							</div>
						</dd>
					</dl>
				</div>
			</div>
		    <span slot="footer" class="dialog-footer">
		    	<el-button @click="dialogVisible = false">取 消</el-button>
		    </span>
		</el-dialog>
		<el-dialog
			:title="dialogDetails.name?dialogDetails.name:'暂无灯组名称'"
			:visible.sync="auditDialogVisible"
			width="300px"
			:close="handleClose">
			<div class="dialogMain cf">				
				<el-select v-model="auditType" placeholder="选择审核状态" class="inputWidth">
					<el-option v-for="item in options" :key="item.id" :label="item.audit" :value="item.id">
					</el-option>
				</el-select>
			</div>
		    <span slot="footer" class="dialog-footer">
			    <el-button @click="auditDialogVisible = false">取 消</el-button>
			    <el-button type="primary" @click="handleConfirm()" :loading="loading">确 定</el-button>
		    </span>
		</el-dialog>
		<!--导航条-->
		<navZcy v-bind:num="'2-2'" style="min-width: 1110px;"></navZcy>
		<div class="line"></div>
		<div class="main">
			<!--页面标题-->
			<div class="top cf">
				<div class="topL fl"><span>灯组方案</span></div>
				<div class="topR fr">
					<el-button type="success" plain @click="refresh"><i class="el-icon-refresh"></i>刷新</el-button>
				</div>
			</div>
			<div class="line"></div>
			<div class="dataTag">
				<!--操作按钮-->
				<div class="handle">
					<div class="handleBtn fl">
						<el-button type="danger" size="small" @click="handleDelete(0,0)">批量删除</el-button>
					</div>
				</div>
				<!--筛选-->
				<div class="filtrateMain">
					<el-row style="text-align: center; padding-bottom: 10px;">
						<el-col :span="4">
							<el-input v-model="filtrateData.lightGroupName" placeholder="灯组名" class="inputWidth"></el-input>
						</el-col>					
						<el-col :span="4">
							<el-input v-model="filtrateData.userAccount" placeholder="账号查询" class="inputWidth"></el-input>
						</el-col>						
						<el-col :span="4">
							<el-input v-model="filtrateData.realName" placeholder="用户名查询" class="inputWidth"></el-input>
						</el-col>	
						<el-col :span="4">
							<el-input v-model="filtrateData.seriesName" placeholder="系列名" class="inputWidth"></el-input>
						</el-col>						
						<el-col :span="4">
							<el-select v-model="filtrateData.styleId" placeholder="风格" class="inputWidth">
								<el-option v-for="item in styleOptions" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-col>
						<el-col :span="4">
							<el-select v-model="filtrateData.brandId" placeholder="品牌" class="inputWidth">
								<el-option v-for="item in brandOptions" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-col>
					</el-row>
					<el-row style="text-align: center;">
						<el-col :span="4">
							<el-select v-model="filtrateData.audit" placeholder="审核状态" class="inputWidth">
								<el-option v-for="item in auditOptions" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-col>
						<el-col :span="4">
							<el-select v-model="filtrateData.baseType" placeholder="所属库型" class="inputWidth">
								<el-option v-for="item in baseTypeOptions" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-col>
						<el-col :span="4" style="line-height: 40px;">
							<el-button type="primary" size="mini" @click="handleSearch()">查询</el-button>
							<el-button type="warning" size="mini" @click="handleReset()">重置</el-button>
						</el-col>
					</el-row>
				</div>
				<!--列表内容-->
				<div class="tableData" style="text-align: center;">
					<el-table 
						ref="multipleTable"
						:data="tableData" 
						border 
						@selection-change="handleSelectionChange" 
						style="width: 100%;border-top: 1px solid #ddd;border-bottom: 1px solid #ddd;">
						<el-table-column type="selection">
						</el-table-column>
						<el-table-column type="index" width="50" label="编号">
					   </el-table-column>
						<el-table-column prop="name" label="灯组名">
						</el-table-column>
						<el-table-column prop="seriesId" label="所属系列">
							<template slot-scope="scope">
								{{seriesIdtoName(scope.row.seriesId)}}
							</template>
						</el-table-column>
						<el-table-column prop="realName" label="用户名" width="125px">
						</el-table-column>
						<el-table-column prop="userAccount" label="用户账号" width="110px">
						</el-table-column>
						<el-table-column prop="price" label="价格">
						</el-table-column>
						<el-table-column prop="imgUrl" label="缩略图" width="63px">
							<template slot-scope="scope">
								<img :src="scope.row.imgUrl" height="20px" alt="缩略图"/>
							</template>
						</el-table-column>
						<el-table-column prop="baseType" label="所属类型" width="78px">
							<template slot-scope="scope">
								{{scope.row.baseType==1?"个人库":"公共库"}}
							</template>
						</el-table-column>
						<el-table-column prop="audit" label="审核状态" width="78px">
							<template slot-scope="scope">
								<div :class="scope.row.audit==2||scope.row.audit==4?'audit':''" @click="changeAuditType(scope.row.audit,scope.row)">{{auditTypeFn(scope.row.audit)}}</div>
							</template>
						</el-table-column>
						<el-table-column prop="createTime" label="创建时间" width="95px">
							<template slot-scope="scope">
								<span>{{dataTimeFn(scope.row.createTime)}}</span>
							</template>
						</el-table-column>
						<el-table-column prop="modifyTime" label="修改时间" width="95px">
							<template slot-scope="scope">
								<span>{{dataTimeFn(scope.row.modifyTime)}}</span>
							</template>
						</el-table-column>
						<!--<el-table-column prop="description" label="描述">
						</el-table-column>-->
						<el-table-column label="操作">
							<template slot-scope="scope">
								<a href="javascript:void(0)" @click="handleDetails(scope.$index, scope.row)" style="color: #1ABC9C;">详情</a>
								<a href="javascript:void(0)" @click="handleDelete(scope.$index, scope.row)" style="color: #1ABC9C;">删除</a>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<!--分页-->
				<div class="page">
					<el-pagination 
						background 
						:current-page="tableDataArr.currentPage" 
						:page-sizes="[10,20,30,40]" 
						:page-size="tableDataArr.pageSize" 
						layout="total, sizes, prev, pager, next, jumper" 
						:total="tableDataArr.totalSize"
				     	@current-change="handleCurrentChange"
				     	@size-change="handleSizeChange">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import '../assets/css/style.css'
import navZcy from './nav'
export default {
	data() {
		return {
			loading: false,
			dialogVisible: false,
			dialogDetails: {},
			filtrateData: {
				lightGroupName: "",		//灯组名
				seriesName: "",	  		//系列名
				styleId: "",		  	//风格
				brandId: "",		  	//品牌
			},
			styleOptions: [],
			brandOptions: [],
			tableDataArr: {			//分页参数
				currentPage: 1,
				pageSize: 10,
				totalSize: 0
			},
			tableData: [],		 	//列表数组参数
			multipleSelection: [],	//列表复选框被选中值
			seriesTag: [], 			//系列表
			sessionId: '',
			auditDialogVisible: false,
			auditType: "",
			options: [{
				id: 3,
				audit: "审核通过"
			}, {
				id: 4,
				audit: "拒绝审核"
			}],
			auditOptions: [{
				id: 1,
				name: "未发布"
			},{
				id: 2,
				name: "未审核"
			},{
				id: 3,
				name: "审核通过"
			}, {
				id: 4,
				name: "拒绝审核"
			}],
			baseTypeOptions: [{
				id: 1,
				name: "个人库"
			},{
				id: 2,
				name: "公共库"
			}]
		}
	},
	methods: {		
		//获取系列列表
		querySeries() {
			let url = "/lightApi/series/inuqirySeries/"+sessionStorage.getItem('sessionId')
			this.$store.dispatch('handlePost',{'url': url, 'data':{},'Fn': this.querySeriesFn,'vue':this})
		},
		querySeriesFn(data) {
			if(data.msg=="ok"){
				this.seriesTag = this.seriesTag.concat(data.data.items)
				this.filtrateData.seriesId = this.seriesTag[0].id
			}else{
				this.seriesTag = []
			}
		},
		seriesIdtoName(id) {
			for (let i=0; i<this.seriesTag.length; i++) {
				if(id==this.seriesTag[i].id){
					return this.seriesTag[i].name
				}
			}
			return '无';
		},
		//获取风格类型
		getStyleTag() {
			let url = "/lightApi/style/inquiryStyle/"+sessionStorage.getItem('sessionId')
			this.$store.dispatch('handlePost',{'url': url, 'data': {},'Fn': this.getStyleTagFn,'vue':this})
		},
		getStyleTagFn(data) {
			if(data.msg=="ok"){
				this.styleOptions = data.data.items
			}else{
				this.styleOptions = []
			}
		},
		styleIdtoName(id) {
			for (let i=0; i<this.styleOptions.length; i++) {
				if(id==this.styleOptions[i].id){
					return this.styleOptions[i].name
				}
			}
		},
		//获取系列品牌类型
		getBrandTag() {
			let url = "/lightApi/brand/inquiryBrand/"+sessionStorage.getItem('sessionId')
			this.$store.dispatch('handlePost',{'url':url, 'data':{}, 'vue':this, 'Fn':this.queryBrandFn})
		},
		queryBrandFn(data) {
			if(data.msg=="ok"){
				this.brandOptions = data.data.items
			}else{
				this.brandOptions = []
			}
		},
		brandIdtoName(id) {
			for (let i=0; i<this.brandOptions.length; i++) {
				if(id==this.brandOptions[i].id){
					return this.brandOptions[i].name
				}
			}
		},
		//获取零件组数据
		queryPrefab() {
			let url = "/lightApi/lightGroup/inquiryLightGroup/" + sessionStorage.getItem('sessionId')
			let data = {
				userAccount: this.filtrateData.userAccount,
				realName: this.filtrateData.realName,
				lightGroupName: this.filtrateData.lightGroupName,
				seriesName: this.filtrateData.seriesName,
				styleId: this.filtrateData.styleId,	  		//用户帐号
				brandId: this.filtrateData.brandId,		  			//用户名
				audit: this.filtrateData.audit,
				baseType: this.filtrateData.baseType,
				currentPage: this.tableDataArr.currentPage,		
				pageSize: this.tableDataArr.pageSize
			}
			this.$store.dispatch('handlePost',{'url': url, 'data': data,'Fn': this.queryPrefabFn,'vue':this})
		},
		queryPrefabFn(data) {
			if(data.msg=="ok"){
				this.tableDataArr = data.data
				this.tableData = this.tableDataArr.items
			}else{
				this.tableData = []
			}
		},
		auditTypeFn(audit) {
			switch(audit){
				case 1:
					return "未发布"
					break;
				case 2:
					return "未审核"
			  		break;
				case 3:
					return "审核通过"
			  		break;
				case 4:
					return "拒绝审核"
			  		break;
				default:
					return "审核状态出错"
			}
		},
		changeAuditType(audit, row) {
			if(audit == 2 || audit == 4) {
				this.loading = false
				this.dialogDetails = row
				this.auditDialogVisible = true
			}
		},
		handleConfirm() {
			this.loading = true
			if(this.auditType){
				let url = "/lightApi/lightGroup/updateLightGroupAuditType/"+sessionStorage.getItem('sessionId')
				let data = {
					lightGroupId: this.dialogDetails.id,
					audit: this.auditType
				}
				this.$store.dispatch('handlePost',{'url':url, 'data':data, 'vue':this, 'Fn':this.changeAuditTypeFn})
			}else{
				this.loading = false
				this.$message({
					type: 'error',
					message: '请选择审核状态'
				});
			}
		},
		changeAuditTypeFn(data) {
			if(data.msg=="ok"){
				this.auditDialogVisible = false
				this.auditType = ""
				this.queryPrefab()
			}else{
				this.loading = false
				this.$message({
					type: 'error',
					message: data.msg
				});
			}
		},
		//页面刷新
		refresh() {
			location.reload()
		},
		//筛选查询
		handleSearch() {
			this.tableDataArr.currentPage = 1
			this.queryPrefab()
		},
		//重置筛选
		handleReset() {
			this.filtrateData = {}
		},
		//零件详情
		handleDetails(index, row) {
			this.dialogDetails = row			
			this.dialogVisible = true
		},
		//弹出框关闭
		handleClose: function(done) {
			done();
		},
		//列表复选框被选中
		handleSelectionChange: function(val){
			this.multipleSelection=[]
			for (let i=0; i<val.length; i++) {
				this.multipleSelection.push(val[i].id)
			}
		},
		//删除零件组
		handleDelete: function(index, row) {
			let id = []
			if(row!=0){
				id[0] = row.id
			}else{
				id = this.multipleSelection					
			}
			if(id.length>0){
				this.$confirm('此操作将永久删除该零件组, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let url = "/lightApi/lightGroup/deleteLightGroup/"+sessionStorage.getItem('sessionId')+"/"+id 
					this.$store.dispatch('handleGet',{'url': url,'Fn': this.handleDeleteFn,'vue':this})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			}else{
				this.$message({
					type: 'info',
					message: '请选择删除项'
				});
			}	
		},
		handleDeleteFn(data) {
			if(data.msg=="ok"){	
				this.queryPrefab()
				this.$message({
					type: 'success',
					message: '删除成功!'
				});
			}else{
				this.$message({
					type: 'error',
					message: data.msg
				});
			}
		},
        //点击页数
		handleCurrentChange(cur) {
			this.tableDataArr.currentPage = cur
			this.queryPrefab()
		},
		//改变显示条目
		handleSizeChange(size) {
			this.tableDataArr.pageSize = size
			this.queryPrefab()
		},
		//时间格式化
		dataTimeFn: function(time){
	   		var oDate
	   		if(time!=""){
				if(typeof(time)=='string'&&time.indexOf(' +0800 CST')!=-1){
					time = time.split(' +0800 CST')[0]
				}
	   			oDate = new Date(time)	
	   		}else{
	   			oDate = new Date()
	   		}
	   					
	  		var mon = oDate.getMonth()+1
	  		var d = oDate.getDate()
	  		if(mon<10){
	  			mon="0"+mon
	  		}
	  		if(d<10){
	  			d="0"+d
	  		}
	  		return oDate.getFullYear()+"-"+mon+"-"+d
	   	}
	},
	created() {
		this.querySeries()
		this.getStyleTag()
		this.getBrandTag()
	},
	mounted() {
		this.sessionId = sessionStorage.getItem('sessionId')
		this.queryPrefab()
	},
	components: {
		navZcy
	}
}
</script>

<style scoped>
.dialogMain .fl dl dt {
	width: 94px;
}

.dialogMain .fr dl dt {
	width: 84px;
}
.audit{
	cursor: pointer;
	color: rgb(26, 188, 156);
}
</style>


// WEBPACK FOOTER //
// src/components/partGroup.vue